import SalesInvoicesReportMutation from 'graphql/mutations/salesLedger/SalesInvoicesReportMutation.graphql';
import SalesInvoiceReportMutation from 'graphql/mutations/salesLedger/SalesInvoiceReportMutation.graphql';
import { customerDocument } from '../../../utils/mailMergeFields';
import * as printFunctions from '../../../actions/salesLedger/salesInvoice/SalesInvoiceWorkspaceAction';
import { EntityType } from '../../../@types/entityTypes';
import { ReportType } from '../../schema/p4types';

const CommercialInvoice: EntityType = {
  type: 'SalesInvoice',
  title: 'Commercial Invoices',
  formTitle: 'Commercial Invoice',
  formUrl: '/Customers/CommercialInvoice/Details/',
  workspaceUrl: '/Customers/CommercialInvoice/Workspace/',
  screenReference: 'SALES_LEDGER_COMMERCIAL_INVOICES',
  printFunctions: printFunctions,
  generate: SalesInvoiceReportMutation,
  generateRange: SalesInvoicesReportMutation,
  configuration: {
    title: 'Commercial Invoice',
    field: 'commercialInvoiceDocumentDefault',
    reportType: ReportType.CommercialInvoice,
    receiveFlag: 'receiveInvoiceDocuments',
  },
  mergeFields: [
    ...customerDocument,
    {
      key: 'orderReference',
      text: 'Order Reference',
    },
    {
      key: 'salesOrderNumbers',
      text: 'Sales Order Numbers',
    },
  ],
};

export default CommercialInvoice;
